import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { transcribeFileIDAndSaveToAnswerResolver } from '../server/transcription.js';

//this one starts the whole chain after a file is uploaded
//takes a file located on the filesystem, transcribes it and saves the transcription to the associated answer
export const transcribeFileIDAndSaveToAnswer = registerMutation({
  operationName: 'transcribeFileIDAndSaveToAnswer',
  resolve: transcribeFileIDAndSaveToAnswerResolver,
  type: () => Boolean,
  params: [
    {
      name: 'fileID',
      type: () => String,
    },
    {
      name: 'answerID',
      type: () => String,
    },
  ],
});
